<div>
	<div>
		<h1 class="order-details-header">Order #{{orderDetail.orderNumber}}</h1>
		<div class="hmf-flex-row w-100 hmf-align-items-center hmf-justify-content-between">
			<span class="header-date">{{orderDetail.placedDate | date: 'longDate'}}</span>
			<span *ngIf="orderDetail.status.toLowerCase() !== 'cancelled' && !isTrackOrderPage && !inStoreOrder && orderDetail.orderType.toLowerCase() !== 'bopis'" class="hmf-ml-xxs hmf-text-decoration-underline hmf-justify-content-flex-end hmf-align-items-center hmf-subheader-l">
				<a class="link"  (click)="openModal()">Resend Confirmation</a>
			</span>
		</div>
		<div *ngIf="orderProxyPerson.firstName">
			<ul class="detail-list-proxy">
				<li><strong>Additional pickup person on order:</strong></li>
				<li>{{orderProxyPerson.firstName}} {{orderProxyPerson.lastName}}</li>
				<li>{{orderProxyPerson.email}}</li>
			</ul>
		</div>
	</div>
	<!-- SAME DAY DELIVERY -->
	<ng-container *ngIf="sameDayItemsBucket.length > 0">
		<div id="sameDayItems" class="order-card-wrapper" *ngFor="let group of sortedSameDayGroups">
			<div class="dcsg-card__border order-detail-card">
				<div class="tracking-details" [ngClass]="{'mb-2': group.groupHeaderText === 'Undeliverable'}">
					<h2 class="card-header icon-text-color">
						<homefield-icon name="order-delivery" class="fulfilment-icon" aria-hidden="true"></homefield-icon>
						<span class="edd-title">{{group.groupHeaderText}}</span>
						<homefield-icon name="sign-check" class="sign-check-icon" aria-hidden="true"></homefield-icon>
					</h2>
					<p class="sdd-edd" *ngIf="group.groupStatusCode === 'Preparing Delivery'">Est. Arrival {{group.groupEstimatedDelivery | date: 'EE, MMM, d' }}</p>
					<p class="tracking-info-text" *ngIf="group.groupTrackingNumber === 'NO_TRACKING_AVAILABLE_YET'; else trackingStatus"><!-- remove else tracking status? -->
						<span class="delivery-window-message">Delivery from 4-7pm. </span><br/>Tracking available once picked up by Dasher.
					</p>
					<my-account-components-progress-tracker *ngIf="group.groupHeaderText !== 'Undeliverable'" [groupStatusPosition]="group.groupStatusCode" [fulfilmentType]="'sameday'"></my-account-components-progress-tracker>
					<div *ngIf="group.groupTrackingUrl && group.groupTrackingNumber !== 'NO_TRACKING_AVAILABLE_YET' && group.groupHeaderText !== 'Undeliverable'" class="shipment-tracking-container">
						<a homefield-button variant="secondary" [href]="group.groupTrackingUrl" target="_blank" class="track-package-link-button" (click)="analyticsClick('TrackPackageClick', 'TrackPackageLinkClicked');">Track Package</a>
					</div>
				</div>
				<div class="shipping-info">
					<ul class="detail-list">
						<li *ngIf="group.groupTrackingUrl && group.groupHeaderText !== 'Undeliverable'" class="delivery-status-items"><strong>Tracking:</strong>&nbsp;<a class="tracking-info-link" (click)="analyticsClick('TrackPackageClick', 'TrackPackageLinkClicked')" [href]="group.groupTrackingUrl" target="_blank">{{group.groupDistributionOrder}}</a></li>
						<li><strong>Delivery Method</strong>: Same Day Delivery</li>
						<li *ngIf="group.groupShippingCity && group.groupShippingState" >
							<strong *ngIf="group.groupStatusCode !== 'Delivered' && group.groupStatusCode !== 'Shipped'" data-test-id="shipping-status">Delivery Address:</strong>
							<strong *ngIf="group.groupTrackingStatus === 'Delivered' || group.groupStatusCode === 'Shipped'" data-test-id="shipping-status">Delivered to:</strong>
							<span *ngIf="group.groupShippingAddress && group.items[0].shippingRecipient else cityStateAddress" data-test-id="shipping-recipient-address">
								{{group.items[0].shippingRecipient.firstName}} {{group.items[0].shippingRecipient.lastName}},
								{{group.groupShippingAddress}}
								{{group.groupShippingCity}}, {{group.groupShippingState}}
								{{group.items[0].shippingRecipient.address?.postalCode}}
							</span>
							<ng-template #cityStateAddress>
								{{group.groupShippingCity}}, {{group.groupShippingState}}
								{{group.items[0].shippingRecipient?.address.postalCode}}
							</ng-template>
						</li>
						<li *ngIf="group.groupTrackingLocation && !group.groupShippingCity" class="delivery-status-items"><strong>Tracking Location:</strong> {{group.trackingLocation}}</li>
					</ul>
				</div>
				<div class="order-items">
					<div class="item" *ngFor="let item of group.items">
						<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
							<img #sameDayImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(sameDayImage, item.imageIdentifier)">
						</a>
						<ul class="detail-list">
							<li class="detail-list-items">
								<strong>
									<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
								</strong>
							</li>
							<li class="detail-list-items">SKU: {{item.sku}}</li>
							<ng-container *ngIf="item.adjustments">
								<li *ngFor="let adjustment of getOrderItemAdjustments(item);" class="adjustment-description">{{adjustment.description}}</li>
							</ng-container>
							<ng-container *ngFor="let attribute of item.attributes">
								<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
									{{attribute.key}}:&nbsp;{{attribute.value}}
								</li>
							</ng-container>
							<li class="detail-list-items">Quantity: {{item.quantity}}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<!-- CANCELLED / RETURNED SAME DAY DELIVERY -->
	<ng-container *ngFor="let statusType of CancelledOrReturnedSameDayDeliveryItems">
		<ng-container *ngIf="returnedOrCancelledSameDayDeliveryItems[statusType].length > 0" >
			<div class="order-card-wrapper">
				<div class="dcsg-card__border order-detail-card">
					<div class="tracking-details hmf-mb-xxxs">
						<h2 class="card-header">
							<homefield-icon name="sign-circled-cancel-filled"></homefield-icon>
							<span class="icon-text-color">{{statusType === 'returned' ? 'Returned' : 'Cancelled'}}</span>
						</h2>
					</div>
					<div class="order-items">
						<div class="item" *ngFor="let item of returnedOrCancelledSameDayDeliveryItems[statusType]">
							<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
								<img #cancelledSameDayImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(cancelledSameDayImage)">
							</a>
							<ul class="detail-list">
								<li class="detail-list-items">
									<strong>
										<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
									</strong>
								</li>
								<li class="detail-list-items">SKU: {{item.sku}}</li>
								<ng-container *ngFor="let attribute of item.attributes">
									<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
										{{attribute.key}}:&nbsp;{{attribute.value}}
									</li>
								</ng-container>
								<li class="detail-list-items">Quantity: {{item.quantity}}</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
	<!-- SHIPPING -->
	<!-- ACTIVE shipping items -->
	<ng-container *ngIf="sortedShippingGroups.length > 0">
		<div id="ShippingItems" class="order-card-wrapper" *ngFor="let group of sortedShippingGroups">
			<div class="dcsg-card__border order-detail-card" *ngIf="group.items.length > 0">
				<div class="tracking-details">
					<h2 class="card-header">
                        <homefield-icon name="vehicle-shipping" class="fulfilment-icon" aria-hidden="true"></homefield-icon><br>
                        <!-- Edge Case: EDD is null -->
                        <span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode === 'Order Placed'">Order Placed</span>
                        <span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode !== 'Order Placed' && group.groupStatusCode !== 'Shipped'">Preparing</span>
                        <span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode === 'Shipped'">Shipped</span>
                        <span *ngIf="group.groupTrackingStatus === 'Delivered'">Delivered</span>
                        <homefield-icon width="2.5rem" height="2rem" name="sign-check" role="img" aria-label="completed"></homefield-icon>
                    </h2>
                    <div class="icon-text-color font-weight-bold">
                        <span class="edd-title" *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode !== 'Shipped' && group.groupEstimatedDelivery !== ''">Est. Delivery: &nbsp;</span>
                        <span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode !== 'Shipped' && group.groupStartEstimatedDelivery !== ''">{{ group.groupStartEstimatedDelivery | date: 'EE, MMM d' }} -&nbsp;</span>
                        <span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode !== 'Shipped' && group.groupEstimatedDelivery !== ''">{{ group.groupEstimatedDelivery | date: 'EE, MMM d' }}</span>
                    </div>
					<p class="tracking-info-text" *ngIf="group.groupTrackingNumber === 'NO_TRACKING_AVAILABLE_YET'; else trackingStatus">Tracking available when shipped</p>
					<ng-template #trackingStatus>
						<p class="tracking-info-text">{{group.groupTrackingStatus}}</p>
					</ng-template>
					<my-account-components-account-progress-tracker [groupStatusPosition]="group.groupStatusCode" [fulfilmentType]="'shipping'"></my-account-components-account-progress-tracker>
					<div *ngIf="group.groupTrackingUrl" class="shipment-tracking-container">
						<a homefield-button variant="secondary" [href]="group.groupTrackingUrl" target="_blank" class="track-package-link-button" (click)="analyticsClick('TrackPackageClick', 'TrackPackageLinkClicked');">Track Package</a>
					</div>
				</div>
				<div class="shipping-info">
					<ul class="detail-list">
						<!-- Shipping Address only available if logged in for online orders -->
						<li *ngIf="group.groupTrackingUrl" class="delivery-status-items"><strong>Tracking:</strong>&nbsp;<a class="tracking-info-link" (click)="analyticsClick('TrackPackageClick', 'TrackPackageLinkClicked')" [href]="group.groupTrackingUrl" target="_blank">{{group.groupTrackingNumber}}</a></li>
						<li *ngIf="group.groupShipModeCode.substring(0,3).toLowerCase() !== 'ltl'; else ltlDelivery" class="delivery-method-items"><strong>Delivery Method</strong>: {{group.groupShipModeCode}}</li>
						<ng-template #ltlDelivery>
							<li class="delivery-method-items"><strong>Delivery Method</strong>: {{group.groupDeliveryMethod}}</li>
						</ng-template>
						<li *ngIf="group.groupTrackingLocation && !group.groupShippingCity" class="delivery-status-items"><strong>Tracking Location:</strong> {{group.groupTrackingLocation}}</li>
						<!-- <li class="delivery-method-items"><strong>Delivery Method</strong>: {{group.groupShipModeCode}}</li> -->
						<li *ngIf="group.groupShippingCity && group.groupShippingState" >
							<strong *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode !== 'Shipped'" data-test-id="shipping-status">Ships to:</strong>
							<strong *ngIf="group.groupTrackingStatus === 'Delivered' || group.groupStatusCode === 'Shipped'" data-test-id="shipping-status">Shipped to:</strong>
							<span *ngIf="group.groupShippingAddress && group.items[0].shippingRecipient else cityStateAddress" data-test-id="shipping-recipient-address">
								{{group.items[0].shippingRecipient.firstName}} {{group.items[0].shippingRecipient.lastName}},
								{{group.groupShippingAddress}}
								{{group.groupShippingCity}}, {{group.groupShippingState}}
								{{group.items[0].shippingRecipient.address?.postalCode}}
							</span>
							<ng-template #cityStateAddress>
								{{group.groupShippingCity}}, {{group.groupShippingState}}
								{{group.items[0].shippingRecipient?.address.postalCode}}
							</ng-template>
						</li>
						<li *ngIf="group.groupTrackingLocation && !group.groupShippingCity" class="delivery-status-items"><strong>Tracking Location:</strong> {{group.trackingLocation}}</li>
					</ul>
				</div>
				<div class="order-items">
					<ng-container *ngFor="let item of group.items; last as isLast">
						<div [ngClass]="{'border-bottom hmf-mb-m-l': !isLast}">
							<div class="item">
								<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
									<img #shippingImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(shippingImage)">
								</a>
								<ul class="detail-list">
									<li class="detail-list-items">
										<strong>
											<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
										</strong>
									</li>
									<li class="detail-list-items">SKU: {{item.sku}}</li>
									<ng-container *ngIf="item.adjustments">
										<li *ngFor="let adjustment of getOrderItemAdjustments(item);" class="adjustment-description">{{adjustment.description}}</li>
									</ng-container>
									<ng-container *ngFor="let attribute of item.attributes">
										<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
											{{attribute.key}}:&nbsp;{{attribute.value}}
										</li>
									</ng-container>
									<li class="detail-list-items">Quantity: {{item.quantity}}</li>
								</ul>
							</div>
							<ng-container *ngIf="buyAgainEnabled && (item.status === 'Delivered' || item.status === 'Fulfilled' || item.status === 'Completed')">
								<button homefield-button (click)="redirectToPDP(item.pdpPageUrl,item.sku)" variant="primary" type="button" class="hmf-mb-l" [ngClass]="{'hmf-mb-s-m': isLast}">Buy Again</button>
								<br>
								<button
									homefield-button
									variant="tertiary"
									type="button"
									class="hmf-mx-0"
									[ngClass]="{'hmf-mb-m': !isLast}"
									(click)="openReviewModal(item.ecode)">
									write a review
								</button>
							</ng-container>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-container>
	<!-- CANCELLED / RETURNED SHIPPING ORDERS -->
	<ng-container *ngFor="let statusType of CancelledOrReturnedShippingItems">
		<ng-container *ngIf="returnedOrCancelledShippingItems[statusType].length > 0">
			<div class="order-card-wrapper">
				<div class="dcsg-card__border order-detail-card">
						<div class="tracking-details hmf-mb-xxxs">
							<h2 class="card-header">
								<homefield-icon name="sign-circled-cancel-filled"></homefield-icon>
								<span class="icon-text-color">{{statusType === 'returned' ? 'Returned' : 'Cancelled'}}</span>
							</h2>
						</div>
						<div class="order-items">
								<div class="item" *ngFor="let item of returnedOrCancelledShippingItems[statusType]">
									<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
										<img #cancelledShippingImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(cancelledShippingImage)">
									</a>
									<ul class="detail-list">
										<li class="detail-list-items">
											<strong>
												<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
											</strong>
										</li>
										<li class="detail-list-items">SKU: {{item.sku}}</li>
										<ng-container *ngFor="let attribute of item.attributes">
											<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
												{{attribute.key}}:&nbsp;{{attribute.value}}
											</li>
										</ng-container>
										<li class="detail-list-items">Quantity: {{item.quantity}}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
			</ng-container>
	</ng-container>
	<!-- BOPIS -->
	<!-- ACTIVE bopis orders -->
	<ng-container *ngIf="sortedActiveBopisItems.length > 0">
		<div *ngFor="let group of sortedActiveBopisItems" class="order-card-wrapper">
			<div class="dcsg-card__border order-detail-card" *ngIf="group.items.length > 0">
				<div class="tracking-details">
                    <div>
                        <h2 class="card-header-bopis icon-text-color" [ngSwitch]="group.status">
                            <homefield-icon name="building-store-dsg-alt" class="fulfilment-icon" aria-hidden="true"></homefield-icon>
                            <span *ngSwitchCase= "'Order Placed'">Order Placed</span>
                            <span *ngSwitchCase= "'In Process'">Preparing Pickup</span>
                            <span *ngSwitchCase= "'Ready For Pickup'">Ready for Pickup</span>
                            <span *ngSwitchCase= "'Picked Up'">Picked up</span>
                            <homefield-icon width="2.5rem" height="2rem" name="sign-check" class="sign-check-icon" role="img" aria-label="completed"></homefield-icon>
                        </h2>
						<ng-container *ngIf="!trackOrder">
							<div *ngFor="let item of group.items" [ngSwitch]="group.locationChain">
								<span *ngSwitchCase="'dsg'" class="hmf-subheader-bold-m">DICK'S - {{item.shippingRecipient.address.address2}}</span><br/>
								<span *ngSwitchCase="'pl'" class="hmf-subheader-bold-m">Public Lands - {{item.shippingRecipient.address.address2}}</span>
								<span *ngSwitchCase="'gg'" class="hmf-subheader-bold-m">Golf Galaxy - {{item.shippingRecipient.address.address2}}</span>
								<span *ngSwitchCase="'ggg'"class="hmf-subheader-bold-m">Going Going Gone! - {{item.shippingRecipient.address.address2}}</span>
								<span>{{toTitleCase(item.shippingRecipient.address.address3)}}, {{toTitleCase(item.shippingRecipient.address.city)}}, {{item.shippingRecipient.address.state}}, {{item.shippingRecipient.address.postalCode}}</span>
							</div>
						</ng-container>
                    </div>
					<p *ngIf="group.locationAddress !== 'USE_NO_ADDRESS'" [ngSwitch]="group.locationChain">
						<span *ngSwitchCase="'dsg'"><homefield-icon height="20" width="140" name="dsg-store-pickup" class="pickup-icon-store" alt="Dick's Sporting Goods"></homefield-icon></span>
						<span *ngSwitchCase="'gg'"><homefield-icon height="20" width="140" name="gg-store-pickup" class="pickup-icon-store" alt="Golf Galaxy"></homefield-icon></span>
						<span *ngSwitchCase="'ggg'"><homefield-icon height="20" width="140" name="ggg-store-pickup" class="pickup-icon-store" alt="Going Going Gone"></homefield-icon></span>
						<span *ngSwitchCase="'pl'"><homefield-icon height="20" width="140" name="pl-store-pickup" class="pickup-icon-store" alt="Public Lands"></homefield-icon></span>
						<br/>
					{{group.locationAddress}}</p>
					<my-account-components-progress-tracker [groupStatusPosition]="group.status" [fulfilmentType]="'bopis'"></my-account-components-progress-tracker>
				</div>
				<div class="shipping-info">
					<span *ngIf="(group.status === 'In Process' || group.status === 'Order Placed') && !orderProxyPerson.firstName">We'll send you an email when its ready for pickup.</span>
					<span *ngIf="(group.status === 'In Process' || group.status === 'Order Placed') && orderProxyPerson.firstName">We'll send you and your designated pickup person an email when its ready for pickup.</span>
					<my-account-components-checkin-button *ngIf="group.status === 'Ready For Pickup'" #checkinComponent [orderDetail]="orderDetail" [zipCode]="getZipcode" [resetCheckIn]="resetCheckIn"></my-account-components-checkin-button>
				</div>
				<div class="order-items">
					<ng-container *ngFor="let item of group.items; last as isLast">
						<div [ngClass]="{'border-bottom hmf-mb-m-l': !isLast}">
							<div class="item">
								<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
									<img #bopisImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(bopisImage)">
								</a>
								<ul class="detail-list">
									<li class="detail-list-items">
										<strong>
											<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
										</strong>
									</li>
									<li class="detail-list-items">SKU: {{item.sku}}</li>
									<ng-container *ngIf="item.adjustments">
										<li *ngFor="let adjustment of getOrderItemAdjustments(item);" class="adjustment-description">{{adjustment.description}}</li>
									</ng-container>
									<ng-container *ngFor="let attribute of item.attributes">
										<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE') ">
											{{attribute.key}}:&nbsp;{{attribute.value}}
										</li>
									</ng-container>
									<li class="detail-list-items">Quantity: {{item.quantity}}</li>
								</ul>
							</div>
							<ng-container *ngIf="buyAgainEnabled && item.status === 'Picked Up'">
								<button homefield-button (click)="redirectToPDP(item.pdpPageUrl,item.sku)" variant="primary" type="button" class="hmf-mb-l" [ngClass]="{'hmf-mb-s-m': isLast}">Buy Again</button>
								<br>
								<button
									homefield-button
									variant="tertiary"
									type="button"
									class="hmf-mx-0"
									[ngClass]="{'hmf-mb-m': !isLast}"
									(click)="openReviewModal(item.ecode)">
									write a review
								</button>
							</ng-container>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-container>
	<!-- CANCELLED BOPIS ORDERS -->
	<ng-container *ngIf="sortedCancelledBopisItems.length > 0">
		<div *ngFor="let group of sortedCancelledBopisItems" class="order-card-wrapper">
			<div class="dcsg-card__border order-detail-card" *ngIf="group.items.length > 0">
				<div class="tracking-details-cancelled hmf-mb-xxxs">
					<h2 class="card-header-bopis">
						<homefield-icon name="sign-circled-cancel-filled"></homefield-icon>
						<span class="icon-text-color">Cancelled {{group.lastUpdated | date: 'MMM d'}}</span>
					</h2>
				</div>
				<div class="shipping-info">
					<!-- Keep proper spacing for layout -->
				</div>
				<div class="order-items">
					<div class="item" *ngFor="let item of group.items">
						<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
							<img #cancelledBopisImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(cancelledBopisImage)">
						</a>
						<ul class="detail-list">
							<li class="detail-list-items">
								<strong>
									<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
								</strong>
							</li>
							<li class="detail-list-items">SKU: {{item.sku}}</li>
							<ng-container *ngIf="item.adjustments">
								<li *ngFor="let adjustment of getOrderItemAdjustments(item);" class="adjustment-description">{{adjustment.description}}</li>
							</ng-container>
							<ng-container *ngFor="let attribute of item.attributes">
								<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
									{{attribute.key}}:&nbsp;{{attribute.value}}
								</li>
							</ng-container>
							<li class="detail-list-items">Quantity: {{item.quantity}}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<!-- RETURNED BOPIS ORDERS -->
	<ng-container *ngIf="sortedReturnedBopisItems.length > 0">
		<div *ngFor="let group of sortedReturnedBopisItems" class="order-card-wrapper">
			<div class="dcsg-card__border order-detail-card" *ngIf="group.items.length > 0">
				<div class="tracking-details-cancelled hmf-mb-xxxs">
					<h2 class="card-header-bopis icon-text-color">Returned {{orderDetail.lastUpdated | date: 'MMM d'}}</h2>
				</div>
				<div class="shipping-info">
					<!-- Keep proper spacing for layout -->
				</div>
				<div class="order-items">
					<div class="item" *ngFor="let item of group.items">
						<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
							<img #returnedBopisImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(returnedBopisImage)">
						</a>
						<ul class="detail-list">
							<li class="detail-list-items">
								<strong>
									<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
								</strong>
							</li>
							<li class="detail-list-items">SKU: {{item.sku}}</li>
							<ng-container *ngIf="item.adjustments">
								<li *ngFor="let adjustment of getOrderItemAdjustments(item);" class="adjustment-description">{{adjustment.description}}</li>
							</ng-container>
							<ng-container *ngFor="let attribute of item.attributes">
								<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
									{{attribute.key}}:&nbsp;{{attribute.value}}
								</li>
							</ng-container>
							<li class="detail-list-items">Quantity: {{item.quantity}}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<!-- IN STORE ORDERS-->
	<ng-container *ngIf="inStoreOrder">
		<div id="InStoreItems" class="order-card-wrapper">
			<div class="dcsg-card__border order-detail-card">
				<div class="order-items in-store-order-items">
					<ng-container *ngFor="let item of orderDetail.items; last as isLast">
						<div [ngClass]="{'border-bottom hmf-mb-m-l': !isLast}">
							<div class="item">
								<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">
									<img #inStoreImage src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" alt="" (error)="handleImageError(inStoreImage, item.imageIdentifier)">
								</a>
								<ul class="detail-list">
									<li class="detail-list-items">
										<strong>
											<a [attr.href]="getLink(item)" [ngStyle]="{'cursor': getLink(item) ? 'pointer' : 'default'}">{{item.name}}</a>
										</strong>
									</li>
									<li class="detail-list-items">SKU: {{item.sku}}</li>
									<ng-container *ngIf="item.adjustments">
										<li *ngFor="let adjustment of getOrderItemAdjustments(item);" class="adjustment-description">{{adjustment.description}}</li>
									</ng-container>
									<ng-container *ngFor="let attribute of item.attributes">
										<li class="detail-list-items" *ngIf="attribute.key && !attribute.key.includes('PRESALE')">
											{{attribute.key}}:&nbsp;{{attribute.value}}
										</li>
									</ng-container>
									<li class="detail-list-items">Quantity: {{item.quantity}}</li>
								</ul>
							</div>
							<div>
							<!--These two skus (20407563 & 14944965 & 13676762) represent donations so we will hide the buy again button for them-->
							<ng-container *ngIf="buyAgainEnabled && (item.sku !== '20407563' && item.sku !== '14944965' && item.sku !== '13676762')">
								<button homefield-button (click)="redirectToPDP(item.pdpPageUrl,item.sku)" variant="primary" type="button" class="hmf-mb-m" [ngClass]="{'hmf-mb-s-m': isLast}">Buy Again</button>
								<br>
								<button
									homefield-button
									variant="tertiary"
									type="button"
									class="hmf-mx-0"
									[ngClass]="{'hmf-mb-m': !isLast}"
									(click)="openReviewModal(item.ecode)">
									write a review
								</button>
							</ng-container>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="in-store-details hmf-flex-s-column hmf-flex-nowrap hmf-justify-content-flex-start">
					<h2 class="card-header">
						<homefield-icon name="building-store-dsg-alt" class="fulfilment-icon" aria-hidden="true"></homefield-icon>
						<span *ngIf="orderDetail.grandTotal > 0; else returnOrder">Store Purchase<homefield-icon width="2.5rem" height="2rem" name="sign-check" role="img" aria-label="completed"></homefield-icon></span>
						<ng-template #returnOrder>Returned In-Store {{orderDetail.placedDate | date: 'EEE, MMMM d' }}</ng-template>
					</h2>
					<p [ngSwitch]="orderDetail.storeChain">
						<span *ngSwitchCase="'dsg'"  class="hmf-subheader-bold-m" >DICK'S - {{orderDetail.storeInfo.storeName}}</span>
						<span *ngSwitchCase="'pl'"  class="hmf-subheader-bold-m">Public Lands - {{orderDetail.storeInfo.storeName}}</span>
						<span *ngSwitchCase="'gg'"  class="hmf-subheader-bold-m">Golf Galaxy - {{orderDetail.storeInfo.storeName}}</span>
						<span *ngSwitchCase="'ggg'"  class="hmf-subheader-bold-m">Going Going Gone! - {{orderDetail.storeInfo.storeName}}</span><br/>
						<span>{{toTitleCase(orderDetail.storeInfo.streetAddress1)}}, {{toTitleCase(orderDetail.storeInfo.city)}}, {{orderDetail.storeInfo.state}} {{orderDetail.storeInfo.zipCode}}</span>
					</p>
				</div>
			</div>
		</div>
	</ng-container>
	<!-- TOTALS -->
	<div id="order-totals-wrapper">
		<div *ngIf="orderCompleted || inStoreOrder" class="returns-button-container">
			<a homefield-button variant="secondary" href="/s/return-policy" target="_blank" class="start-return-link-button" (click)="analyticsClick('StartReturnClick', 'ClickedStartReturn');">Start A Return</a>
		</div>
		<div id="order-totals">
			<table id="order-totals-table">
				<tr>
					<td>Order Subtotal:</td>
					<td>{{orderDetail.subTotal | currency}}</td>
				</tr>
				<tr>
					<td>Shipping &amp; Handling:</td>
					<td>{{orderDetail.totalShippingCharge !== 0 ? (orderDetail.totalShippingCharge | currency) : 'FREE'}}</td>
				</tr>
				<ng-container *ngIf="orderDetail.adjustments.length > 0">
					<tr *ngFor="let adjustment of orderAdjustments; last as isLast" class="adjustment-description">
						<ng-container>
							<td>{{adjustment.description}}&nbsp;<homefield-icon height="14px" width="14px" class="info-icon" name="alert-info-filled" (click)="openDiscountModal(adjustment)" aria-label="View adjustment details" role="button"></homefield-icon></td>
							<td>{{adjustment.amount | currency}}</td>
						</ng-container>
					</tr>
				</ng-container>
				<ng-container *ngIf="orderDetail.manualAdjustments.length > 0">
					<tr *ngFor="let adjustment of orderManualAdjustments; last as isLast">
						<td>Your {{getManualAdjustmentAmount(adjustment) | currency : 'USD' : 'symbol' : '1.0' }} Reward
							has been applied to your order!&nbsp;<homefield-icon height="14px" width="14px" class="info-icon adjustment-rewards" name="alert-info-filled" (click)="openDiscountModal(adjustment)" aria-label="View adjustment details" role="button"></homefield-icon></td>
						<td>{{getManualAdjustmentAmount(adjustment) | currency}}</td>
					</tr>
				</ng-container>
				<tr>
					<td class="icon-cell"><span *ngIf="orderDetail.isEstimatedTax === undefined || orderDetail.isEstimatedTax">Estimated</span> Tax: <homefield-icon id="tax-details" height="14px" width="14px"  name="alert-info-filled" (click)="openTaxDisclaimerModal()" aria-label="tax details" role="button"></homefield-icon></td>
					<td>{{orderDetail.totalTax | currency}}</td>
				</tr>
				<tr>
					<td><strong>Order Total</strong>:</td>
					<td><strong>{{orderDetail.grandTotal | currency}}</strong></td>
				</tr>
			</table>
		</div>
		<div *ngIf="!trackOrder && !inStoreOrder" class="payment-summary-container">
			<chk-payment-summary class="payment-summary" [orderPayments]="orderDetail.payments" [addresses]="orderDetail.billingAddress" [proxyPickup]="proxyPickup"></chk-payment-summary>
		</div>
		<div *ngIf="inStoreOrder" class="payment-summary-container">
			<chk-payment-summary class="payment-summary" [orderPayments]="orderDetail.payments" [contact]="identity"></chk-payment-summary>
		</div>
	</div>
</div>

<hmf-modal
	#resendConfirmationModal
	[className]="'resend-confirmation-modal'"
	[transparentBackground]="false"
	[closable]="true"
	[closableVariant]="'primary'"
	[interactability]="false"
	[clickableBackground]="true"
	[focus]="true">
	<my-account-order-track-components-confirm-email-modal #emailComponent
		[identity]="identity"
		[addresses]="orderDetail.billingAddress"
		[orderNumber]="orderDetail.orderNumber"
		(closeEvent)="closeModal()">
	</my-account-order-track-components-confirm-email-modal>
</hmf-modal>
